<div class="container p-0">
    <div class="modal-header">
      <h3 class="modal-title">Location</h3>
      <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
    {{this.injectedData | json}}
  <div id="map" style="height: 340px;"></div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeModal()">Close</button>
      </div> 
  </div>
  
